export const SET_DATES = "SET_DATES";
export const SET_FOCUSED_INPUT = "SET_FOCUSED_INPUT";



// WEBPACK FOOTER //
// ./src/cleaning/schedule/dateRangePicker/constants.js